import React, { FC } from 'react';
import Icon from '@common/assets';

import { ModalTypes } from '@components/mypage/common/modalsWrap';
import Colors from '@domain/constant/colors';
import { JobApplicationProcessType } from '@domain/constant/jobApplicationProcessType';
import classnames from 'classnames/bind';
import styles from './applyBtn.module.scss';
const cx = classnames.bind(styles);

interface Props {
  statusType: JobApplicationProcessType;
  openModal: (modalState: ModalTypes) => void;
}

const ApplyBtn: FC<Props> = ({ statusType, openModal }) => {
  //지원 취소
  const handleCancelApply = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    openModal('RESUME_DELETE');
  };

  return (
    <div className={cx('applyBtnWrap')}>
      <button className={cx('applyBtn')} onClick={handleCancelApply}>
        <Icon name="deleteLight" width={32} height={32} fill={Colors.C_COOL_GRAY_70} />
        <span className={cx('hidden')}>{`resume ${statusType} btn`}</span>
      </button>
    </div>
  );
};

export default ApplyBtn;
